import React, { useState, useEffect } from 'react';
import './styles.css';
import CompanySelection from './components/CompanySelection';
import FundSelection from './components/FundSelection';
import ParameterSelection from './components/ParameterSelection';
import ChartComponent from './components/ChartComponent';
import FinalSummary from './components/FinalSummary';
import {
  initAuth, getCompetitors, getFunds, getPolicyComparison, getPolicyComparisonGraph, getFinalSummary, getFundHero,
  getFundFooter,
  getFundLogo, testEncryptLoginId
} from './services/apiService';
function App() {
  const [currentStep, setCurrentStep] = useState(1);
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [footerData, setFooterData] = useState(null);
  const [headerData, setHeaderData] = useState(null);
  const [selectedCompanies, setSelectedCompanies] = useState({});
  const [selectedFunds, setSelectedFunds] = useState({});
  const [selectedAge, setSelectedAge] = useState(null);
  const [selectedSA, setSelectedSA] = useState(null);
  const [fundsData, setFundsData] = useState([]);
  const [chartData, setChartData] = useState(null);
  const [policyData, setPolicyData] = useState(null);
  const [finalSummaryData, setFinalSummaryData] = useState(null);
  useEffect(() => {
    const init = async () => {

      testEncryptLoginId();
      const isAuth = await initAuth();
      if (!isAuth) return;



      const [logo, hero, footer] =
        await Promise.all([
          getFundLogo(),
          getFundHero(),
          getFundFooter(),
        ]);
      const mergedHeader = {
        ...hero,
        ...logo,
      };
      setHeaderData(
        mergedHeader
      );

      setFooterData(
        footer || null
      );

      await loadCompanies();

      setLoading(false);

    };

    init();

  }, []);


  const loadCompanies = async () => {
    const companiesData = await getCompetitors();
    setCompanies(companiesData);
  };

  const handleCompanySelect = (key) => {
    setSelectedCompanies(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const handleSelectAllCompanies = () => {
    const updated = {};

    companies.forEach((company) => {
      updated[company._id] = true;
    });

    setSelectedCompanies(updated);
  };
  const handleClearAllCompanies = () => {
    const updated = {};

    companies.forEach((company) => {
      updated[company._id] = false;
    });

    setSelectedCompanies(updated);
  };
  const handleShowFunds = async () => {

    const selected = Object.keys(selectedCompanies)
      .filter(id => selectedCompanies[id]);



    if (selected.length === 0) {
      alert('Please select at least one company.');
      return;
    }

    try {

      const funds = await getFunds(selected);



      setFundsData([...funds]);
      setCurrentStep(2);

    } catch (error) {

    }
  };
  const handleFundSelect = (companyKey, fundName) => {
    setSelectedFunds(prev => ({
      ...prev,
      [companyKey]: fundName
    }));
  };

  const handleShowParams = () => {

    const selected = Object.keys(selectedCompanies)
      .filter(id => selectedCompanies[id]);

    if (selected.length === 0) {
      alert('Please select at least one company');
      return;
    }

    const missingCompany = companies.find(
      company =>
        selectedCompanies[company._id] &&
        !selectedFunds[company._id]
    );

    if (missingCompany) {

      alert(
        `Please select fund for ${missingCompany.name}`
      );

      return;
    }

    setCurrentStep(3);
  };

  const handleAgeSelect = (age) => {
    setSelectedAge(age);
  };

  const handleSASelect = (sa) => {
    setSelectedSA(sa);
  };
  const handleRunComparison = async (mode = "all") => {
    const selected = Object.keys(selectedCompanies).filter(
      key => selectedCompanies[key]
    );

    const hasSelectedFunds = selected.some(key => selectedFunds[key]);

    if (!hasSelectedFunds) {
      alert('Please select at least one fund');
      return;
    }

    if (!selectedAge || !selectedSA) {
      alert('Please select Age and Sum Assured');
      return;
    }
    if (mode === "full") {
      setChartData(null);
      setFinalSummaryData(null);
    }

    const comparisons = [];


    const normalize = (s) =>
      (s || "")
        .toLowerCase()
        .replace(/\bfund\b/g, "")
        .replace(/\s+/g, " ")
        .trim();
    fundsData.forEach((comp) => {

      const selectedFund = selectedFunds[comp._id];

      if (!selectedFund) return;

      const fundObj = (comp.funds || []).find((f) => {

        const backendName = normalize(f["Fund Name"]);
        const selectedName = normalize(selectedFund);

        return (
          backendName === selectedName ||
          backendName.includes(selectedName) ||
          selectedName.includes(backendName)
        );
      });

      if (!fundObj) return;

      comparisons.push({
        competitorId: comp._id,
        fundName: fundObj["Fund Name"]
      });
    });

    if (comparisons.length === 0) {
      alert("Fund mapping failed. Please reselect funds.");
      return;
    }

    const payload = {
      age: Number(selectedAge),
      sumAssured: Number(selectedSA),
      comparisons
    };

    try {
      const policyResult = await getPolicyComparison(payload);

      if (policyResult?.success && policyResult.data?.comparisons?.length > 0) {
        setPolicyData(policyResult.data.comparisons);
      }
      if (mode === "full") {
        const [chartResult, summaryResult] = await Promise.all([
          getPolicyComparisonGraph(payload),
          getFinalSummary(payload)
        ]);

        if (chartResult?.success) {
          setChartData(chartResult.data);
        }

        if (summaryResult?.success) {
          setFinalSummaryData(summaryResult.data);
        }

        setCurrentStep(4);
      }

    } catch (err) {

    }
  };

  if (loading) {
    return
  }
  return (
    <div className="App">
   <nav>

  <div className="nav-logo">

    <div className="logo-box">

      <img
        src={
          headerData?.logoUrl
            ? headerData.logoUrl
            : "/logo/tata-logo.png"
        }
        alt={
          headerData?.fundName ||
          "Logo"
        }
        className="logo-img"
      />

    </div>

    <div className="logo-tag">

      {
        headerData?.fundName ||
        ""
      }

    </div>

  </div>

</nav>

      {/* HERO */}
      <div className="hero">
        <h1>
          {headerData?.badgeText && (
            <span style={{ marginRight: "6px" }}>
              {headerData.badgeText}
            </span>
          )}
          {headerData?.title || "Smart Fund Value Comparison"}
        </h1>

        <p>
          {headerData?.subtitle || "Compare TATA AIA Products vs Competitors"}
        </p>
      </div>

      {/* MAIN CONTAINER */}
      <div className="container">

        {/* STEP 1 */}
        <div className={`step-card ${currentStep < 1 ? 'hidden' : ''}`}>
          <div className="step-header">
            <div className="step-num">1</div>
            <div>
              <div className="step-title">Select Companies</div>
              <div style={{ fontSize: '13px', color: '#888' }}>
                Choose the companies you want to compare
              </div>
            </div>
          </div>

          <div className="step-body">
            <CompanySelection
              companies={companies}
              selectedCompanies={selectedCompanies}
              onCompanySelect={handleCompanySelect}
              onSelectAll={handleSelectAllCompanies}
              onClearAll={handleClearAllCompanies}
            />

            <div className="ctrl-row">
              <button className="btn-primary" onClick={handleShowFunds}>
                Show Funds →
              </button>
            </div>
          </div>
        </div>

        {/* STEP 2 */}
        <div className={`step-card ${currentStep < 2 ? 'hidden' : ''}`} id="card-funds">
          <div className="step-header">
            <div className={`step-num ${currentStep > 2 ? 'done' : ''}`}>2</div>
            <div>
              <div className="step-title">Select Fund per Company</div>
              <div style={{ fontSize: '13px', color: '#888' }}>
                Use the radio button on the left to select one fund per company Fund returns- As on July 2026
              </div>
            </div>
          </div>

          <div className="step-body">
            <FundSelection
              selectedCompanies={selectedCompanies}
              selectedFunds={selectedFunds}
              onFundSelect={handleFundSelect}
              fundsData={fundsData}
              companies={companies}
            />

            <div className="ctrl-row" style={{ marginTop: '16px' }}>
              <button className="btn-primary" onClick={handleShowParams}>
                Continue →
              </button>
            </div>
          </div>
        </div>
        {currentStep >= 3 && (
          <div className="step-card">
            <div className="step-header">
              <div className={`step-num ${currentStep > 3 ? 'done' : ''}`}>3</div>
              <div>
                <div className="step-title">Select Parameters</div>
                <div style={{ fontSize: '13px', color: '#888' }}>
                  Choose Age & Sum Assured
                </div>
              </div>
            </div>

            <div className="step-body">
              <ParameterSelection
                selectedAge={selectedAge}
                selectedSA={selectedSA}
                onAgeSelect={handleAgeSelect}
                onSASelect={handleSASelect}
                selectedFunds={selectedFunds}
                selectedCompanies={selectedCompanies}
                onRunComparison={handleRunComparison}
                policyData={policyData}
              />


            </div>
          </div>
        )}



        {/* STEP 4 */}
        {currentStep === 4 && (
          <>
            <ChartComponent chartData={chartData} />
            <FinalSummary finalSummaryData={finalSummaryData} />
          </>
        )}

        {/* FOOTER */}


      </div>
      <footer>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <div style={{ fontSize: '16px', fontWeight: '700', marginBottom: '8px' }}>
            {footerData?.companyName || "TATA AIA Life Insurance Co. Ltd."}
          </div>

          <div>
            {footerData?.registrationNumber || "IRDAI Reg. No. 110"}
            {" | "}
            <a href="#">Privacy Policy</a>
            {" | "}
            <a href="#">Terms & Conditions</a>
            {" | "}
            {footerData?.phoneNumber || "1800-267-9966"}
          </div>

          <div style={{ marginTop: '8px', opacity: '.7', fontSize: '12px' }}>
            {footerData?.disclaimer ||
              "Unit Linked Insurance Products are subject to market risks. Please read the Fund Information Document carefully before investing."}
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
